import React, {useEffect, useRef, useState} from "react";
import {Affix, Button, Col, Dropdown, Input, List, Menu, Popconfirm, Row, Spin, Switch} from "antd";
import i18next from "i18next";
import * as Setting from "../../conf/Setting";
import * as IconFont from "../../components/common/IconFont";
import * as AccountActivationBackend from "../../services/AccountActivationBackend";
import moment from "moment";
import {v4 as uuidv4} from "uuid";
import "../../assets/styles/password/PasswordPolicyPage.less";
import {WechatOutlined} from "@ant-design/icons";
import {ReactSortable} from "react-sortablejs";

const activationProcessIcon = {
  userVerify: <IconFont.MessageFilleIcon style={{fontSize: 16, marginRight: 6, color: "#2389EB"}} />,
  WeChat: <WechatOutlined style={{fontSize: 16, marginRight: 6, color: "#33B46E"}} />,
  WeCom: <IconFont.WeComIcon style={{fontSize: 16, marginRight: 6, color: "#2E70AF"}} />,
  WeChatOfficial: <WechatOutlined style={{fontSize: 16, marginRight: 6, color: "#33B46E"}} />,
  email: <IconFont.MailIcon style={{fontSize: 16, marginRight: 6, color: "#E89924"}} />,
  phone: <IconFont.MobileIcon style={{fontSize: 16, marginRight: 6, color: "#2389EB"}} />,
  password: <IconFont.LockFilledIcon style={{fontSize: 16, marginRight: 6, color: "#FA5B5D"}} />,
};

export const AccountActivateSetting = (props) => {
  const newActivatonConfig = () => {
    const randomName = Setting.getRandomName();
    return {
      owner: Setting.Admin,
      uid: uuidv4(),
      displayName: `新配置 - ${randomName}`,
      createdTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      flow: [
        {
          value: "userVerify",
          enableSkip: false,
        },
        {
          value: "password",
          enableSkip: false,
        },
      ],
      isDefault: false,
    };
  };

  const [dataList, setDataList] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [config, setConfig] = useState(null);
  const [mode, setMode] = useState("");
  const [currentSelect, setCurrentSelect] = useState(-1);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [originConfig, setOriginConfig] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [draggableFlow, setDraggableFlow] = useState([]);

  const inputDisplayNameRef = useRef();

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    AccountActivationBackend.getConfigs(Setting.Admin).then(res => {
      if (res.msg === undefined) {
        const list1 = res.filter(config => !config.isDefault);
        const list2 = res.filter(config => config.isDefault);
        const list = [...list2, ...list1];
        if (list.length > 0) {
          setMode("");
          setCurrentSelect(0);
          getConfig(list[0].owner, list[0].uid);
        }
        setDataList(list);
      } else {
        Setting.showResponseMessage(res.msg);
      }
    }).catch(error => {
      Setting.showResponseMessage(error);
    });
  };

  const getConfig = (owner, uid) => {
    setLoadingData(true);
    AccountActivationBackend.getConfig(owner, uid).then(res => {
      setLoadingData(false);
      if (res.msg === undefined) {
        setConfig(res);
        setDisplayName(res.displayName);
      } else {
        Setting.showResponseMessage(res.msg);
      }
    }).catch(error => {
      setLoadingData(false);
      Setting.showResponseMessage(error);
    });
  };

  const parseField = (key, value) => {
    return value;
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const updateConfigField = (key, value) => {
    value = parseField(key, value);

    setConfig({
      ...config,
      [key]: value,
    });
  };

  const editing = () => {
    if (mode === "add" || mode === "edit") {
      return true;
    }
    return false;
  };

  const onClickAddNewConfig = () => {
    setLoadingAdd(true);
    const config = newActivatonConfig();
    config.flow = config.flow.map(item => JSON.stringify(item));
    AccountActivationBackend.addConfig(config)
      .then(resAdd => {
        if (resAdd.status === "ok") {
          AccountActivationBackend.getConfigs(Setting.Admin).then(res => {
            setLoadingAdd(false);
            if (res.msg === undefined) {
              const list1 = res.filter(config => !config.isDefault);
              const list2 = res.filter(config => config.isDefault);
              const list = [...list2, ...list1];
              setDataList(list);
              if (list.length > 0) {
                setMode("add");
                const foundIndex = list.findIndex(item => item.uid === config.uid);
                setCurrentSelect(foundIndex);
                const policyTemp = Setting.deepCopy(list[foundIndex]);
                getConfig(policyTemp.owner, policyTemp.uid);
              }
            } else {
              Setting.showResponseMessage(res.msg);
            }
          }).catch(error => {
            setLoadingAdd(false);
            Setting.showResponseMessage(error);
          });
        } else {
          setLoadingAdd(false);
          Setting.showResponseMessage(resAdd.msg);
        }
      })
      .catch(error => {
        setLoadingAdd(false);
        Setting.showResponseMessage(error);
      });
  };

  const onClickSave = () => {
    if (displayName.trim() === "") {
      Setting.showResponseMessage(i18next.t("password:Please input display name"));
      return;
    }

    const flows = draggableFlow.map((item) => (JSON.stringify({enableSkip: item.enableSkip, value: item.value})));
    const saveFlows = [config.flow[0], ...flows, config.flow[config.flow.length - 1]];

    const saveConfig = {
      ...config,
      flow: saveFlows,
      displayName,
    };
    setLoadingSave(true);
    AccountActivationBackend.updateConfig(saveConfig, saveConfig.owner, saveConfig.uid)
      .then(res => {
        setLoadingSave(false);
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully saved"));
          setDataList(dataList.map(item => {
            if (item.uid === saveConfig.uid) {
              return saveConfig;
            }
            return item;
          }));
          setConfig(saveConfig);
          setOriginConfig(saveConfig);
          setMode("");
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        setLoadingSave(false);
        Setting.showResponseMessage(error);
      });
  };

  const onClickDelete = () => {
    AccountActivationBackend.deleteConfig(config)
      .then(res => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("activationConfig:Config deleted successfully"));
          getDataList();
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  };

  const onClickCancel = () => {
    if (mode === "add") {
      setLoadingCancel(true);
      AccountActivationBackend.deleteConfig(config)
        .then(res => {
          setLoadingCancel(false);
          if (res.status === "ok") {
            getDataList();
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          setLoadingCancel(false);
          Setting.showResponseMessage(error);
        });
    } else {
      setConfig(originConfig);
      setDisplayName(originConfig.displayName);
      setMode("");
    }
  };

  const renderFlowStep = (flowStep, menuFlow, handleUpdateRequire = null, handleAddStep = null, handleDeleteStep = null) => {
    return <div key={flowStep.value}
      data-id = {flowStep.value}
      data-step={JSON.stringify(flowStep)}
      style={{display: "flex", marginBottom: 20}}>
      <div
        style={{height: 50, flex: 1, borderRadius: "4px", border: "1px solid #E8E8E8", display: "flex", alignItems: "center"}}
      >
        <div className="handle" style={{width: 35, height: 20, textAlign: "center"}}>
          {
            !editing() || flowStep.value === "userVerify" || flowStep.value === "password" ? null
              :
              <IconFont.DragIcon style={{fontSize: 16, color: "#BBBBBB", cursor: "grab"}} />
          }
        </div>
        <Col style={{width: 110, marginRight: 4}}>{activationProcessIcon[flowStep.value]}<span style={{fontSize: 14, fontWeight: 600, color: "rgba(0, 0, 0, 0.85)"}}>{Setting.activationProcess[flowStep.value].labelText}</span></Col>
        <Col style={{flex: 1, color: "rgba(0, 0, 0, 0.45)"}}>{Setting.activationProcess[flowStep.value].description}</Col>
        <Col style={{width: 110, marginRight: 50}}>
          <span style={{color: "rgba(0, 0, 0, 0.45)"}}>{i18next.t("activationConfig:Required")}</span>
          <Switch style={{marginLeft: 10}} disabled={!editing() || flowStep.value === "userVerify" || flowStep.value === "password"} checked={!flowStep.enableSkip} onChange={(value) => {
            const updatedStep = {
              value: flowStep.value,
              enableSkip: value ? false : true,
            };
            handleUpdateRequire && handleUpdateRequire(updatedStep);
          }} />
        </Col>
      </div>
      <div style={{width: 90, display: "flex", alignItems: "center"}}>
        {
          flowStep.value === "userVerify" || flowStep.value === "password" || !editing() ?
            null :
            <Popconfirm
              title={i18next.t("activationConfig:Sure to delete this step")}
              onConfirm={() => {
                handleDeleteStep && handleDeleteStep();
              }}
            >
              <IconFont.CircleMinusIcon hidden={!editing()} style={{fontSize: 24, color: "rgba(35, 137, 235, 0.25)", marginLeft: 12}} />
            </Popconfirm>
        }
        {
          flowStep.value !== "password" && editing() ?
            <Dropdown
              overlay={() => {
                return <Menu onClick={(e) => {
                  const newFlow = {
                    value: e.key,
                    enableSkip: false,
                  };
                  handleAddStep && handleAddStep(newFlow);
                }}>
                  {
                    menuFlow.map(item =>
                      <Menu.Item key={item}>{Setting.activationProcess[item].labelText}</Menu.Item>
                    )
                  }
                </Menu>;
              }}
              placement="bottomLeft"
              disabled={menuFlow.length === 0}
            >
              <IconFont.CirclePlusIcon style={{fontSize: 24, color: "#2389EB", marginLeft: 12}} />
            </Dropdown>
            :
            null
        }
      </div>
    </div>;
  };

  const renderContent = (currentConfig) => {
    const firstFlow = JSON.parse(currentConfig.flow[0]);
    const lastFlow = JSON.parse(currentConfig.flow[currentConfig.flow.length - 1]);
    const middleFlow = currentConfig.flow.length > 2 ? currentConfig.flow.slice(1, currentConfig.flow.length - 1) : [];

    const menuFlow = [];
    Setting.allActivationProcess.map(proc => {
      const foundIndexOfDraggable = draggableFlow.findIndex(item => {
        if (item.value === proc) {
          return true;
        }
        return false;
      });

      if (firstFlow.value !== proc && lastFlow.value !== proc && foundIndexOfDraggable === -1) {
        menuFlow.push(proc);
      }
    });

    const showFlows = middleFlow.map((item, index) => {
      const flowStep = JSON.parse(item);
      return flowStep;
    });

    return <>
      <div className="ua-password-policy-input" style={{marginLeft: 32}}>
        {
          renderFlowStep(firstFlow, menuFlow,
            null, (newFlow) => {
              const updatedFlow = [...draggableFlow];
              updatedFlow.splice(0, 0, newFlow);
              setDraggableFlow(updatedFlow);
            }, null)
        }
      </div>
      <div className="ua-password-policy-input" style={{marginLeft: 32}}>
        {
          mode === "add" || mode === "edit" ?
            <ReactSortable list={draggableFlow}
              handle=".handle"
              setList={setDraggableFlow}
              onUpdate={() => {}}
            >
              {
                draggableFlow.map((flowStep, index) => {
                  return renderFlowStep(flowStep, menuFlow,
                    (updateStep) => {
                      const updatedFlow = [...draggableFlow];
                      updatedFlow.splice(index, 1, updateStep);
                      setDraggableFlow(updatedFlow);
                    }, (newFlow) => {
                      const updatedFlow = [...draggableFlow];
                      updatedFlow.splice(index + 1, 0, newFlow);
                      setDraggableFlow(updatedFlow);
                    }, () => {
                      const updatedFlow = [...draggableFlow];
                      updatedFlow.splice(index, 1);
                      setDraggableFlow(updatedFlow);
                    });
                })
              }
            </ReactSortable>
            :
            showFlows.map((flowStep) => {
              return renderFlowStep(flowStep, menuFlow);
            })
        }
      </div>
      <div className="ua-password-policy-input" style={{marginLeft: 32}}>
        {renderFlowStep(lastFlow, menuFlow)}
      </div>
    </>;

  };

  const opButtonStyle = {
    minWidth: "70px",
    height: "32px",
    marginRight: "12px",
    borderRadius: "2px",
  };

  return (
    <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
      <Row style={{flex: 1}}>
        <Col span={4} style={{background: "#F5FBFF", textAlign: "center",
          overflow: "auto",
          height: "calc(100vh - 130px)",
        }}>
          <List
            className="ua-password-policy-list"
            header={<div style={{height: 1}}></div>}
            split={false}
            dataSource={dataList}
            renderItem={(item, index) => (
              <div className={`ua-password-policy-list-item ${index === currentSelect ? "ua-password-policy-list-item-selected" : ""}`}
                onClick={() => {
                  if (index !== currentSelect) {
                    setMode("");
                    setCurrentSelect(index);
                    getConfig(item.owner, item.uid);
                  }
                }}>
                {item.displayName}
              </div>
            )
            }
          />
          <Affix offsetBottom={30} style={{height: 56}}>
            <div style={{background: "#F5FBFF"}}>
              <Button icon={<IconFont.PlusIcon />} style={{marginTop: 10, background: "transparent", width: "calc(100% - 48px)", borderRadius: "2px"}}
                onClick={onClickAddNewConfig} loading={loadingAdd}>{i18next.t("activationConfig:New Config")}</Button>
            </div>
          </Affix>
        </Col>
        {
          loadingData ?
            <Col span={20} style={{border: "1px solid #EEEEEE", overflow: "auto"}}>
              <Row style={{height: "100%"}} type="flex" justify="center" align="middle">
                <Spin size="large" />
              </Row>
            </Col>
            :
            <Col span={20} style={{border: "1px solid #EEEEEE", overflow: "auto"}}>
              <div style={{display: "flex", justifyContent: "space-between", marginBottom: 20}}>
                <div style={{fontSize: 16, fontWeight: 600, color: "#333333", marginTop: 26, marginLeft: 32}}>
                  <Input hidden={!editing()} placeholder={i18next.t("activationConfig:Please input name")} value={displayName} style={{width: 200, height: 30}}
                    ref={inputDisplayNameRef}
                    onChange={(e) => {
                      setDisplayName(e.target.value);
                    }} />
                  <div hidden={editing()}>
                    <span>{displayName}</span>
                  </div>
                </div>
                <div style={{marginTop: 21}}>
                  {
                    editing() ?
                      <Button type="primary" ghost style={opButtonStyle} disabled={config?.isDefault} loading={loadingCancel} onClick={() => {
                        onClickCancel();
                      }}>
                        {i18next.t("general:Cancel")}
                      </Button>
                      :
                      <Popconfirm
                        title={`${i18next.t("activationConfig:Sure to delete this config")}`}
                        onConfirm={() => onClickDelete()}
                        placement="bottomRight"
                        disabled={config?.isDefault}
                      >
                        <Button type="primary" ghost style={opButtonStyle} disabled={config?.isDefault}>
                          {i18next.t("general:Delete")}
                        </Button>
                      </Popconfirm>
                  }
                  {
                    editing() ?
                      <Button type="primary" style={opButtonStyle} onClick={onClickSave} loading={loadingSave} disabled={config?.isDefault}>
                        {i18next.t("general:Save")}
                      </Button>
                      :
                      <Button type="primary" style={opButtonStyle} onClick={() => {
                        setMode("edit");
                        setOriginConfig(config);
                        const middleFlow = config.flow.length > 2 ? config.flow.slice(1, config.flow.length - 1) : [];

                        const flows = middleFlow.map((item, index) => {
                          const flowStep = JSON.parse(item);
                          return flowStep;
                        });
                        setDraggableFlow(flows);
                      }} disabled={config?.isDefault}>
                        {i18next.t("general:Edit")}
                      </Button>
                  }
                </div>
              </div>
              {config ? renderContent(config) : null}
            </Col>
        }
      </Row>
    </div>
  );
};

export default AccountActivateSetting;
